import { ServiceType } from "../../../Models/ServiceType";
import OrderHandler from "../OrderHandler";
import Mediator from "../../../Utilities/Mediator";
import Service from "../../../Models/Service";
import VariantTile from "./VariantTile";
import { createImg } from "../../../DomUtilities/ElementsCreator";
import Variant from "../../../Models/Variant";
import MeasurementModal from "./Modals/MeasurementModal";
import CanvasModal from "./Modals/CanvasModal";

export default class ChooseVariant {
	serviceIndex: number;
	service: Service;
	variantTiles: HTMLDivElement[];
	variantsWrapper: HTMLDivElement;
	stepsWrapper: HTMLDivElement;
	serviceTile: HTMLDivElement;

	constructor(service: Service) {
		this.service = service; // service with all variants
		this.variantTiles = new Array<HTMLDivElement>();
		this.variantsWrapper = document.createElement('div');
		this.variantsWrapper.classList.add("variants");
		this.stepsWrapper = document.querySelector('.create-order > div');
		this.serviceIndex = OrderHandler.selectedItem.services.findIndex(s => s.id === this.service.id);

		this.init();
	}

	private init() {
		if (this.service.variants.length === 1) {
			this.addVariant(new Variant(this.service.variants[0]));
		} else {
			this.service.variants.sort((v1, v2) => v1.displayOrder - v2.displayOrder);
			Mediator.emit("serviceIsSelected");
			this.createVariantsTiles();
			this.createSelectedServiceTile();
		}

		Mediator.on("variantSelected", () => this.removeVariants());
	}

	private createVariantsTiles() {
		const separator = document.createElement('hr');

		this.variantsWrapper.innerHTML = "";
		this.stepsWrapper.appendChild(this.variantsWrapper);
		this.variantsWrapper.appendChild(separator);

		this.service.variants.forEach(variant => {
			const variantTile = new VariantTile(variant);
			this.variantsWrapper.appendChild(variantTile.variantTile);
			this.variantTiles.push(variantTile.variantTile);
			this.addVariantsSelectionClickListener(variantTile.variantTile, variant);
		});
	}

	private createSelectedServiceTile() {
		const src: string = this.service.image ? this.service.image : "/assets/no_image_placeholder.png";
		const serviceTileWrapper = document.createElement('div');
		this.serviceTile = document.createElement('div');
		const icon = createImg(src, `${this.service.name} ikon`);
		const serviceName = document.createElement('p');
		const selectedItemTopClass = OrderHandler.items.find(i => i.isFastTrack) ? "selected-item--fast-track" : "selected-item--no-fast-track";

		this.serviceTile.id = this.service.id;
		this.serviceTile.title = this.service.name;
		this.serviceTile.classList.add("selected-item", selectedItemTopClass);
		serviceName.innerText = this.service.name;

		this.serviceTile.appendChild(icon);
		this.serviceTile.appendChild(serviceName);
		serviceTileWrapper.appendChild(this.serviceTile);
		this.stepsWrapper.appendChild(serviceTileWrapper);
	}

	private addVariantsSelectionClickListener(variantTile: HTMLDivElement, variant: Variant) {
		variantTile.onclick = () => {
			variantTile.classList.add('--selected');
			const index: number = OrderHandler.selectedItem.services[this.serviceIndex].variants.findIndex(v => v.id === variant.id);
			if (index === -1) {
				this.addVariant(new Variant(variant));
			}
		}
	}

	private addVariant(variant: Variant) {
		const backToStep1: boolean = OrderHandler.selectedItem.hasSimpleOrderFlow;
		variant.itemId = OrderHandler.selectedItem.itemId;

		switch (this.service.type) {
			case ServiceType.Measurements:
				new MeasurementModal(this.service, variant);
				break;
			case ServiceType.Canvas:
				if (!OrderHandler.selectedItem.services[this.serviceIndex].variants.find(v => v.id == variant.id)) {
					OrderHandler.selectedItem.services[this.serviceIndex].variants.push(variant);
					Mediator.emit("variantIsSelected");
					Mediator.off("canvasVariantSelected");
					Mediator.on("canvasVariantSelected", () => new CanvasModal(this.service));
					if (backToStep1) {
						new CanvasModal(this.service);
					}
				}
				break;
			default:
				OrderHandler.selectedItem.services[this.serviceIndex].variants.splice(0, 1, variant);
				Mediator.emit("serviceCostChanged", this.service.id, variant.cost);
				OrderHandler.addSelectedItemToShoppingCart();
				Mediator.emit("variantIsSelected", this.service.variants.length > 1, backToStep1);
				break;
		}
	}

	private removeVariants(): void {
		if (this.service.variants.length > 1) {
			this.variantsWrapper.remove();
			this.serviceTile.remove();
		}
	}
}
